module.exports = __webpack_public_path__ + "img/qiancai-back-code@2x.6f2ff74d.png";